import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-529abd32"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nge-profile-topbar" }
const _hoisted_2 = { class: "nge-profile-topbar-label" }
const _hoisted_3 = { class: "nge-profile-topbar-name" }
const _hoisted_4 = { class: "nge-profile-tabbar" }
const _hoisted_5 = {
  key: 0,
  class: "nge-profile-body"
}
const _hoisted_6 = { class: "nge-profile-col nge-profile-col--left" }
const _hoisted_7 = {
  key: 0,
  class: "nge-profile-header"
}
const _hoisted_8 = { class: "nge-profile-name-row" }
const _hoisted_9 = ["src"]
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 0,
  class: "nge-profile-flag-picker"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  key: 1,
  class: "nge-profile-flag-wrap"
}
const _hoisted_16 = ["src"]
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "nge-profile-name" }
const _hoisted_19 = {
  key: 0,
  class: "nge-profile-username"
}
const _hoisted_20 = {
  key: 0,
  class: "nge-profile-bio"
}
const _hoisted_21 = { class: "nge-profile-section nge-profile-section--edits" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-section-label" }, "▌ Edits", -1 /* HOISTED */))
const _hoisted_23 = { class: "nge-profile-stat-row" }
const _hoisted_24 = { class: "nge-profile-stat-label" }
const _hoisted_25 = { class: "nge-profile-stat-val" }
const _hoisted_26 = { class: "nge-profile-stat-breakdown" }
const _hoisted_27 = {
  class: "nge-profile-stat-bp",
  title: "Merges"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "nge-profile-stat-icon nge-profile-stat-icon--merge",
  viewBox: "0 0 16 16",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M4 3v4a4 4 0 0 0 4 4h0a4 4 0 0 0 4-4V3",
    stroke: "currentColor",
    "stroke-width": "1.8",
    "stroke-linecap": "round"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "4",
    cy: "2.5",
    r: "1.5",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "2.5",
    r: "1.5",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "8",
    cy: "13",
    r: "1.5",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M8 11v2",
    stroke: "currentColor",
    "stroke-width": "1.8",
    "stroke-linecap": "round"
  })
], -1 /* HOISTED */))
const _hoisted_29 = {
  class: "nge-profile-stat-bp",
  title: "Splits"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "nge-profile-stat-icon nge-profile-stat-icon--split",
  viewBox: "0 0 16 16",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M8 3v2a4 4 0 0 1-4 4H4",
    stroke: "currentColor",
    "stroke-width": "1.8",
    "stroke-linecap": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M8 3v2a4 4 0 0 0 4 4h0",
    stroke: "currentColor",
    "stroke-width": "1.8",
    "stroke-linecap": "round"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "8",
    cy: "2.5",
    r: "1.5",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "4",
    cy: "13",
    r: "1.5",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "13",
    r: "1.5",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M4 9v4M12 9v4",
    stroke: "currentColor",
    "stroke-width": "1.8",
    "stroke-linecap": "round"
  })
], -1 /* HOISTED */))
const _hoisted_31 = {
  key: 1,
  class: "nge-profile-section nge-profile-section--cells"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-section-label" }, "▌ Cells", -1 /* HOISTED */))
const _hoisted_33 = { class: "nge-profile-stat-row nge-profile-stat-row--tiles" }
const _hoisted_34 = {
  class: "nge-profile-stat-col nge-profile-stat-tile",
  title: "Cells you proofread all the way to completion"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-stat-label" }, "Completed", -1 /* HOISTED */))
const _hoisted_36 = { class: "nge-profile-stat-val nge-profile-stat-val--hero" }
const _hoisted_37 = {
  class: "nge-profile-stat-col nge-profile-stat-tile",
  title: "Cells you identified (typed) without proofreading edits"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-stat-label" }, "Identified", -1 /* HOISTED */))
const _hoisted_39 = { class: "nge-profile-stat-val" }
const _hoisted_40 = {
  class: "nge-profile-stat-col nge-profile-stat-tile",
  title: "Every cell you have worked on in any way"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-stat-label" }, "Total", -1 /* HOISTED */))
const _hoisted_42 = { class: "nge-profile-stat-val" }
const _hoisted_43 = {
  key: 0,
  class: "nge-profile-stat-col nge-profile-stat-tile",
  title: "Cells where you helped answer another player's request"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-stat-label" }, "Assists", -1 /* HOISTED */))
const _hoisted_45 = {
  class: "nge-profile-stat-val",
  style: {"color":"#7f8"}
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nge-profile-section-label",
  style: {"margin-top":"14px"}
}, "▌ Scout Report", -1 /* HOISTED */))
const _hoisted_47 = { class: "nge-profile-stat-row" }
const _hoisted_48 = { class: "nge-profile-stat-col" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-stat-label" }, "Tags Placed", -1 /* HOISTED */))
const _hoisted_50 = {
  class: "nge-profile-stat-val",
  style: {"color":"#f5d142"}
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-stat-sub" }, "scouted", -1 /* HOISTED */))
const _hoisted_52 = { class: "nge-profile-stat-col" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-stat-label" }, "Confirmed", -1 /* HOISTED */))
const _hoisted_54 = { class: "nge-profile-stat-val" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-stat-sub" }, "of yours, fixed", -1 /* HOISTED */))
const _hoisted_56 = { class: "nge-profile-stat-col" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-stat-label" }, "You Fixed", -1 /* HOISTED */))
const _hoisted_58 = {
  class: "nge-profile-stat-val",
  style: {"color":"#9d9"}
}
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-stat-sub" }, "scythe work", -1 /* HOISTED */))
const _hoisted_60 = {
  key: 0,
  class: "nge-cell-list"
}
const _hoisted_61 = { class: "nge-cell-list-header" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-cell-list-title" }, "Recent Cells", -1 /* HOISTED */))
const _hoisted_63 = ["title"]
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-cell-list-columns" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "nge-cell-col-label nge-cell-col-label--id" }, "Segment"),
  /*#__PURE__*/_createElementVNode("span", { class: "nge-cell-col-label nge-cell-col-label--type" }, "Type"),
  /*#__PURE__*/_createElementVNode("span", { class: "nge-cell-col-label nge-cell-col-label--time" }, "When")
], -1 /* HOISTED */))
const _hoisted_65 = { class: "nge-cell-list-scroll" }
const _hoisted_66 = ["title"]
const _hoisted_67 = ["onClick"]
const _hoisted_68 = ["onClick"]
const _hoisted_69 = ["onClick"]
const _hoisted_70 = ["onClick"]
const _hoisted_71 = ["onClick"]
const _hoisted_72 = {
  key: 1,
  class: "nge-cell-empty"
}
const _hoisted_73 = { class: "nge-profile-col nge-profile-col--center" }
const _hoisted_74 = { class: "nge-profile-section nge-profile-section--badges" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nge-profile-section-label",
  style: {"color":"#ffd08a"}
}, "▌ Proofreading Achievements", -1 /* HOISTED */))
const _hoisted_76 = {
  key: 0,
  class: "nge-profile-countdown-inline"
}
const _hoisted_77 = { class: "nge-profile-countdown-row" }
const _hoisted_78 = { class: "nge-profile-countdown-remaining" }
const _hoisted_79 = { class: "nge-profile-countdown-track" }
const _hoisted_80 = { class: "nge-profile-badges-grid" }
const _hoisted_81 = ["title", "onClick"]
const _hoisted_82 = { class: "nge-profile-badge-img" }
const _hoisted_83 = ["src", "alt"]
const _hoisted_84 = { class: "nge-profile-badge-name" }
const _hoisted_85 = {
  key: 0,
  class: "nge-profile-badge nge-profile-badge--locked",
  title: 'Next: keep editing to unlock!'
}
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-badge-img" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-badge-mystery" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "nge-profile-badge-mystery-q" }, "?")
  ])
], -1 /* HOISTED */))
const _hoisted_87 = [
  _hoisted_86
]
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-badge-img" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-badge-viewall-icon" }, "→")
], -1 /* HOISTED */))
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-badge-name" }, "View all", -1 /* HOISTED */))
const _hoisted_90 = [
  _hoisted_88,
  _hoisted_89
]
const _hoisted_91 = {
  key: 1,
  class: "nge-profile-badges-empty"
}
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-badges-divider" }, null, -1 /* HOISTED */))
const _hoisted_93 = { class: "nge-profile-section nge-profile-section--badges" }
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nge-profile-section-label",
  style: {"color":"#90fff2"}
}, "▌ Cell Achievements", -1 /* HOISTED */))
const _hoisted_95 = {
  key: 0,
  class: "nge-profile-countdown-inline"
}
const _hoisted_96 = { class: "nge-profile-countdown-row" }
const _hoisted_97 = { class: "nge-profile-countdown-remaining" }
const _hoisted_98 = { class: "nge-profile-countdown-track" }
const _hoisted_99 = { class: "nge-profile-badges-grid" }
const _hoisted_100 = ["title", "onClick"]
const _hoisted_101 = { class: "nge-profile-badge-img" }
const _hoisted_102 = ["src", "alt"]
const _hoisted_103 = { class: "nge-profile-badge-name" }
const _hoisted_104 = {
  key: 0,
  class: "nge-profile-badge nge-profile-badge--locked",
  title: 'Next: complete more cells to unlock!'
}
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-badge-img" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-badge-mystery" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "nge-profile-badge-mystery-q" }, "?")
  ])
], -1 /* HOISTED */))
const _hoisted_106 = [
  _hoisted_105
]
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-badge-img" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-badge-viewall-icon" }, "→")
], -1 /* HOISTED */))
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-badge-name" }, "View all", -1 /* HOISTED */))
const _hoisted_109 = [
  _hoisted_107,
  _hoisted_108
]
const _hoisted_110 = {
  key: 1,
  class: "nge-profile-badges-empty"
}
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-badges-divider" }, null, -1 /* HOISTED */))
const _hoisted_112 = { class: "nge-profile-section nge-profile-section--badges nge-profile-section--special" }
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-section-label" }, "★ Special Awards", -1 /* HOISTED */))
const _hoisted_114 = { class: "nge-profile-badges-grid" }
const _hoisted_115 = ["title", "onClick"]
const _hoisted_116 = { class: "nge-profile-badge-img" }
const _hoisted_117 = ["src", "alt"]
const _hoisted_118 = { class: "nge-profile-badge-name" }
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-badge-img" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-badge-viewall-icon" }, "→")
], -1 /* HOISTED */))
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-badge-name" }, "View all", -1 /* HOISTED */))
const _hoisted_121 = [
  _hoisted_119,
  _hoisted_120
]
const _hoisted_122 = { class: "nge-profile-col nge-profile-col--right" }
const _hoisted_123 = {
  key: "special",
  class: "nge-profile-viz-panel nge-profile-viz-badge nge-profile-viz-badge--detail"
}
const _hoisted_124 = ["src", "alt"]
const _hoisted_125 = { class: "nge-profile-viz-badge-name" }
const _hoisted_126 = {
  key: 0,
  class: "nge-profile-viz-badge-desc"
}
const _hoisted_127 = { class: "nge-profile-viz-badge-threshold" }
const _hoisted_128 = {
  key: "latest",
  class: "nge-profile-viz-panel nge-profile-viz-badge"
}
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-viz-title" }, "⭐ Favorite Badge", -1 /* HOISTED */))
const _hoisted_130 = ["src", "alt"]
const _hoisted_131 = { class: "nge-profile-viz-badge-name" }
const _hoisted_132 = { class: "nge-profile-viz-badge-desc" }
const _hoisted_133 = { class: "nge-profile-viz-badge-threshold" }
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-viz-title" }, "⭐ Favorite Badge", -1 /* HOISTED */))
const _hoisted_135 = ["src", "alt"]
const _hoisted_136 = { class: "nge-profile-viz-badge-name" }
const _hoisted_137 = {
  key: 0,
  class: "nge-profile-viz-badge-desc"
}
const _hoisted_138 = { class: "nge-profile-viz-badge-threshold" }
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-viz-title" }, "▌ Latest Badge", -1 /* HOISTED */))
const _hoisted_140 = ["src", "alt"]
const _hoisted_141 = { class: "nge-profile-viz-badge-name" }
const _hoisted_142 = { class: "nge-profile-viz-badge-desc" }
const _hoisted_143 = { class: "nge-profile-viz-badge-threshold" }
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-viz-title" }, "▌ Badges", -1 /* HOISTED */))
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nge-profile-viz-badge-desc",
  style: {"margin-top":"40px"}
}, " Make edits and complete cells to earn badges! ", -1 /* HOISTED */))
const _hoisted_146 = {
  key: "badge",
  class: "nge-profile-viz-panel nge-profile-viz-badge nge-profile-viz-badge--detail"
}
const _hoisted_147 = ["src", "alt"]
const _hoisted_148 = { class: "nge-profile-viz-badge-name" }
const _hoisted_149 = { class: "nge-profile-viz-badge-desc" }
const _hoisted_150 = { class: "nge-profile-viz-badge-threshold" }
const _hoisted_151 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-right-divider" }, null, -1 /* HOISTED */))
const _hoisted_152 = {
  key: 0,
  class: "nge-profile-section nge-profile-section--podium"
}
const _hoisted_153 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-section-label nge-profile-section-label--amber" }, "▌ Top of the Week", -1 /* HOISTED */))
const _hoisted_154 = {
  key: 0,
  class: "nge-profile-podium-metric"
}
const _hoisted_155 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-podium-metric-label" }, "Edits", -1 /* HOISTED */))
const _hoisted_156 = { class: "nge-profile-podium-row" }
const _hoisted_157 = ["title"]
const _hoisted_158 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-profile-podium-medal" }, "🥇", -1 /* HOISTED */))
const _hoisted_159 = { class: "nge-profile-podium-count" }
const _hoisted_160 = ["title"]
const _hoisted_161 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-profile-podium-medal" }, "🥈", -1 /* HOISTED */))
const _hoisted_162 = { class: "nge-profile-podium-count" }
const _hoisted_163 = ["title"]
const _hoisted_164 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-profile-podium-medal" }, "🥉", -1 /* HOISTED */))
const _hoisted_165 = { class: "nge-profile-podium-count" }
const _hoisted_166 = {
  key: 1,
  class: "nge-profile-podium-metric"
}
const _hoisted_167 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-podium-metric-label" }, "Cells", -1 /* HOISTED */))
const _hoisted_168 = { class: "nge-profile-podium-row" }
const _hoisted_169 = ["title"]
const _hoisted_170 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-profile-podium-medal" }, "🥇", -1 /* HOISTED */))
const _hoisted_171 = { class: "nge-profile-podium-count" }
const _hoisted_172 = ["title"]
const _hoisted_173 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-profile-podium-medal" }, "🥈", -1 /* HOISTED */))
const _hoisted_174 = { class: "nge-profile-podium-count" }
const _hoisted_175 = ["title"]
const _hoisted_176 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-profile-podium-medal" }, "🥉", -1 /* HOISTED */))
const _hoisted_177 = { class: "nge-profile-podium-count" }
const _hoisted_178 = { class: "nge-profile-section nge-profile-section--streak" }
const _hoisted_179 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-section-label nge-profile-section-label--amber" }, "▌ Streak", -1 /* HOISTED */))
const _hoisted_180 = {
  key: 0,
  class: "nge-profile-streak-row"
}
const _hoisted_181 = { class: "nge-profile-streak-current" }
const _hoisted_182 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-profile-streak-flame" }, "🔥", -1 /* HOISTED */))
const _hoisted_183 = { class: "nge-profile-streak-count" }
const _hoisted_184 = { class: "nge-profile-streak-unit" }
const _hoisted_185 = {
  key: 0,
  class: "nge-profile-streak-best"
}
const _hoisted_186 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-profile-streak-best-label" }, "Best", -1 /* HOISTED */))
const _hoisted_187 = { class: "nge-profile-streak-best-val" }
const _hoisted_188 = { class: "nge-profile-activity-chart" }
const _hoisted_189 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-chart-label" }, "Last 14 Days", -1 /* HOISTED */))
const _hoisted_190 = { class: "nge-profile-chart-bars" }
const _hoisted_191 = ["title"]
const _hoisted_192 = { class: "nge-profile-chart-bar-wrap" }
const _hoisted_193 = { class: "nge-profile-chart-day" }
const _hoisted_194 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-profile-chart-legend" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "nge-profile-chart-legend-item" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "nge-profile-chart-legend-dot nge-profile-chart-legend-dot--edit" }),
    /*#__PURE__*/_createTextVNode(" Edits ")
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "nge-profile-chart-legend-item" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "nge-profile-chart-legend-dot nge-profile-chart-legend-dot--completion" }),
    /*#__PURE__*/_createTextVNode(" Completions ")
  ])
], -1 /* HOISTED */))
const _hoisted_195 = { class: "nge-profile-body nge-profile-body--trophy" }
const _hoisted_196 = { class: "nge-trophy-scroll" }
const _hoisted_197 = {
  key: 0,
  class: "nge-trophy-featured"
}
const _hoisted_198 = { class: "nge-trophy-featured-effects" }
const _hoisted_199 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-trophy-ring nge-trophy-ring--1" }, null, -1 /* HOISTED */))
const _hoisted_200 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-trophy-ring nge-trophy-ring--2" }, null, -1 /* HOISTED */))
const _hoisted_201 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-trophy-ring nge-trophy-ring--3" }, null, -1 /* HOISTED */))
const _hoisted_202 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-trophy-ring nge-trophy-ring--4" }, null, -1 /* HOISTED */))
const _hoisted_203 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-trophy-ring nge-trophy-ring--5" }, null, -1 /* HOISTED */))
const _hoisted_204 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-trophy-aura" }, null, -1 /* HOISTED */))
const _hoisted_205 = ["src", "alt"]
const _hoisted_206 = { class: "nge-trophy-featured-info" }
const _hoisted_207 = { class: "nge-trophy-featured-name nge-trophy-featured-name--scifi" }
const _hoisted_208 = {
  key: 0,
  class: "nge-trophy-featured-desc"
}
const _hoisted_209 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nge-trophy-featured-desc",
  style: {"font-style":"italic","opacity":"0.7"}
}, "Won for being awesome", -1 /* HOISTED */))
const _hoisted_210 = { class: "nge-trophy-featured-threshold" }
const _hoisted_211 = {
  key: 1,
  class: "nge-trophy-featured-fav-label"
}
const _hoisted_212 = ["title"]
const _hoisted_213 = {
  key: 1,
  class: "nge-trophy-featured"
}
const _hoisted_214 = { class: "nge-trophy-featured-effects" }
const _hoisted_215 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-trophy-ring nge-trophy-ring--1" }, null, -1 /* HOISTED */))
const _hoisted_216 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-trophy-ring nge-trophy-ring--2" }, null, -1 /* HOISTED */))
const _hoisted_217 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-trophy-ring nge-trophy-ring--3" }, null, -1 /* HOISTED */))
const _hoisted_218 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-trophy-ring nge-trophy-ring--4" }, null, -1 /* HOISTED */))
const _hoisted_219 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-trophy-ring nge-trophy-ring--5" }, null, -1 /* HOISTED */))
const _hoisted_220 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-trophy-aura" }, null, -1 /* HOISTED */))
const _hoisted_221 = ["src", "alt"]
const _hoisted_222 = { class: "nge-trophy-featured-info" }
const _hoisted_223 = { class: "nge-trophy-featured-name nge-trophy-featured-name--scifi" }
const _hoisted_224 = {
  key: 0,
  class: "nge-trophy-featured-desc"
}
const _hoisted_225 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nge-trophy-featured-desc",
  style: {"font-style":"italic","opacity":"0.7"}
}, "Won for being awesome", -1 /* HOISTED */))
const _hoisted_226 = { class: "nge-trophy-featured-threshold" }
const _hoisted_227 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-trophy-featured-fav-label" }, "★ Your favorite badge", -1 /* HOISTED */))
const _hoisted_228 = {
  key: 2,
  class: "nge-trophy-featured"
}
const _hoisted_229 = { class: "nge-trophy-featured-effects" }
const _hoisted_230 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-trophy-ring nge-trophy-ring--1" }, null, -1 /* HOISTED */))
const _hoisted_231 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-trophy-ring nge-trophy-ring--2" }, null, -1 /* HOISTED */))
const _hoisted_232 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-trophy-ring nge-trophy-ring--3" }, null, -1 /* HOISTED */))
const _hoisted_233 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-trophy-ring nge-trophy-ring--4" }, null, -1 /* HOISTED */))
const _hoisted_234 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-trophy-ring nge-trophy-ring--5" }, null, -1 /* HOISTED */))
const _hoisted_235 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-trophy-aura" }, null, -1 /* HOISTED */))
const _hoisted_236 = ["src", "alt"]
const _hoisted_237 = { class: "nge-trophy-featured-info" }
const _hoisted_238 = { class: "nge-trophy-featured-name nge-trophy-featured-name--scifi" }
const _hoisted_239 = { class: "nge-trophy-featured-desc" }
const _hoisted_240 = { class: "nge-trophy-featured-threshold" }
const _hoisted_241 = {
  key: 0,
  class: "nge-trophy-featured-fav-label"
}
const _hoisted_242 = ["title"]
const _hoisted_243 = { class: "nge-trophy-track" }
const _hoisted_244 = {
  class: "nge-trophy-track-label",
  style: {"color":"#90fff2"}
}
const _hoisted_245 = { class: "nge-trophy-track-count" }
const _hoisted_246 = { class: "nge-trophy-grid" }
const _hoisted_247 = ["onClick"]
const _hoisted_248 = ["src", "alt"]
const _hoisted_249 = { class: "nge-trophy-badge-name" }
const _hoisted_250 = { class: "nge-trophy-badge-desc" }
const _hoisted_251 = { class: "nge-trophy-badge-threshold" }
const _hoisted_252 = { class: "nge-trophy-track" }
const _hoisted_253 = {
  class: "nge-trophy-track-label",
  style: {"color":"#ffd08a"}
}
const _hoisted_254 = { class: "nge-trophy-track-count" }
const _hoisted_255 = { class: "nge-trophy-grid" }
const _hoisted_256 = ["onClick"]
const _hoisted_257 = ["src", "alt"]
const _hoisted_258 = { class: "nge-trophy-badge-name" }
const _hoisted_259 = { class: "nge-trophy-badge-desc" }
const _hoisted_260 = { class: "nge-trophy-badge-threshold" }
const _hoisted_261 = {
  key: 3,
  class: "nge-trophy-track"
}
const _hoisted_262 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-trophy-track-label" }, "★ Special Awards", -1 /* HOISTED */))
const _hoisted_263 = { class: "nge-trophy-grid" }
const _hoisted_264 = ["title", "onClick"]
const _hoisted_265 = ["src", "alt"]
const _hoisted_266 = { class: "nge-trophy-badge-name" }
const _hoisted_267 = {
  key: 0,
  class: "nge-trophy-badge-desc"
}
const _hoisted_268 = {
  key: 2,
  class: "nge-profile-body nge-profile-body--datasets"
}
const _hoisted_269 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-ds-tab-intro" }, " Your contributions across datasets. Click one to switch the viewer to it. ", -1 /* HOISTED */))
const _hoisted_270 = {
  key: 0,
  class: "nge-ds-tab-loading"
}
const _hoisted_271 = { class: "nge-ds-tab-grid" }
const _hoisted_272 = ["onClick"]
const _hoisted_273 = { class: "nge-ds-tab-card-head" }
const _hoisted_274 = { class: "nge-ds-tab-species" }
const _hoisted_275 = { class: "nge-ds-tab-label" }
const _hoisted_276 = {
  key: 0,
  class: "nge-ds-tab-badge"
}
const _hoisted_277 = {
  key: 1,
  class: "nge-ds-tab-switch"
}
const _hoisted_278 = { class: "nge-ds-tab-desc" }
const _hoisted_279 = { class: "nge-ds-tab-stats" }
const _hoisted_280 = { class: "nge-ds-tab-stat" }
const _hoisted_281 = { class: "nge-ds-tab-stat" }
const _hoisted_282 = { class: "nge-ds-tab-stat" }
const _hoisted_283 = {
  key: 0,
  class: "nge-ds-tab-stat nge-ds-tab-stat--none"
}
const _hoisted_284 = {
  key: 1,
  class: "nge-ds-tab-stat nge-ds-tab-stat--none"
}
const _hoisted_285 = {
  key: 3,
  class: "nge-profile-body nge-profile-body--week"
}
const _hoisted_286 = {
  key: 4,
  class: "nge-profile-body nge-profile-body--admin"
}
const _hoisted_287 = {
  key: 5,
  class: "nge-profile-body nge-profile-body--settings"
}
const _hoisted_288 = { class: "nge-special-modal" }
const _hoisted_289 = { class: "nge-special-modal-head" }
const _hoisted_290 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-special-modal-title" }, "★ All Special Awards", -1 /* HOISTED */))
const _hoisted_291 = { class: "nge-special-modal-grid" }
const _hoisted_292 = ["title", "onClick"]
const _hoisted_293 = ["src", "alt"]
const _hoisted_294 = { class: "nge-special-modal-name" }
const _hoisted_295 = {
  key: 0,
  class: "nge-special-modal-reason"
}
const _hoisted_296 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-badge-zoom-halo" }, null, -1 /* HOISTED */))
const _hoisted_297 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-badge-zoom-ring" }, null, -1 /* HOISTED */))
const _hoisted_298 = ["src", "alt"]
const _hoisted_299 = { class: "nge-badge-zoom-name" }
const _hoisted_300 = {
  key: 0,
  class: "nge-badge-zoom-desc"
}
const _hoisted_301 = {
  key: 1,
  class: "nge-badge-zoom-meta"
}
const _hoisted_302 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-badge-zoom-hint" }, "Tap anywhere to close", -1 /* HOISTED */))

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock($setup["ModalOverlay"], {
    id: "nge-profile-modal",
    class: _normalizeClass(["nge-profile-modal", { 'nge-profile-closing': $setup.closing }]),
    onHide: $setup.handleClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        ref: "shellEl",
        class: _normalizeClass(["nge-profile-shell", { 'nge-profile-shell--trophy': $setup.activeTab === 'trophyCase', 'nge-profile-shell--admin': $setup.activeTab === 'adminHub', 'nge-profile-shell--week': $setup.activeTab === 'weekInScience', 'nge-profile-shell--datasets': $setup.activeTab === 'datasets', 'nge-profile-shell--settings': $setup.activeTab === 'settings' }])
      }, [
        _createCommentVNode(" ── Topbar ─────────────────────────────────────────── "),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("span", _hoisted_2, [
            _createTextVNode("◈ "),
            _createElementVNode("span", _hoisted_3, _toDisplayString($setup.profileUsername || $setup.profileName), 1 /* TEXT */),
            _createTextVNode(" · RESEARCHER PROFILE")
          ]),
          _createElementVNode("button", {
            class: "nge-profile-exit",
            onClick: $setup.handleClose
          }, "×")
        ]),
        _createCommentVNode(" ── Tab bar ─────────────────────────────────────────── "),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: _normalizeClass(["nge-profile-tab", { 'nge-profile-tab--active': $setup.activeTab === 'overview' }]),
            onClick: _cache[0] || (_cache[0] = $event => ($setup.activeTab = 'overview'))
          }, "Overview", 2 /* CLASS */),
          _createElementVNode("button", {
            class: _normalizeClass(["nge-profile-tab", { 'nge-profile-tab--active': $setup.activeTab === 'trophyCase' }]),
            onClick: _cache[1] || (_cache[1] = $event => ($setup.activeTab = 'trophyCase'))
          }, "🏆 Trophy Case", 2 /* CLASS */),
          (!$setup.viewingOtherUser)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: _normalizeClass(["nge-profile-tab", { 'nge-profile-tab--active': $setup.activeTab === 'datasets' }]),
                onClick: _cache[2] || (_cache[2] = $event => ($setup.activeTab = 'datasets'))
              }, "🧬 Datasets", 2 /* CLASS */))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" Hidden by default (Amy 2026-08-11): the tab button only appears\n             while you're ON it, i.e. arrived via the toolbar Week icon or a\n             recap notification deep-link. "),
          (!$setup.viewingOtherUser && $setup.activeTab === 'weekInScience')
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: _normalizeClass(["nge-profile-tab", { 'nge-profile-tab--active': true }]),
                onClick: _cache[3] || (_cache[3] = $event => ($setup.openWeekInScience()))
              }, "📊 My Week in Science"))
            : _createCommentVNode("v-if", true),
          (!$setup.viewingOtherUser)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                class: _normalizeClass(["nge-profile-tab", { 'nge-profile-tab--active': $setup.activeTab === 'settings' }]),
                onClick: _cache[4] || (_cache[4] = $event => ($setup.activeTab = 'settings'))
              }, "⚙️ Settings", 2 /* CLASS */))
            : _createCommentVNode("v-if", true),
          (!$setup.viewingOtherUser && $setup.backendStore.isAdmin)
            ? (_openBlock(), _createElementBlock("button", {
                key: 3,
                class: _normalizeClass(["nge-profile-tab", { 'nge-profile-tab--active': $setup.activeTab === 'adminHub' }]),
                onClick: _cache[5] || (_cache[5] = $event => ($setup.activeTab = 'adminHub'))
              }, "🛠 Admin Hub", 2 /* CLASS */))
            : _createCommentVNode("v-if", true)
        ]),
        _createCommentVNode(" ── Three-column body (Overview tab) ────────────────── "),
        ($setup.activeTab === 'overview')
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createCommentVNode(" LEFT: stats + recent cells "),
              _createElementVNode("div", _hoisted_6, [
                _createCommentVNode(" Header "),
                ($setup.sessions.length > 0 || $setup.viewingOtherUser)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createCommentVNode(" Flag (editable only for own profile) "),
                        (!$setup.viewingOtherUser)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              id: "nge-profile-flag-wrap",
                              class: "nge-profile-flag-wrap",
                              onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
                            }, [
                              _createElementVNode("button", {
                                class: _normalizeClass(["nge-profile-flag", { 'nge-profile-flag--active': $setup.showFlagPicker }]),
                                onClick: _cache[6] || (_cache[6] = $event => ($setup.showFlagPicker = !$setup.showFlagPicker)),
                                title: "Click to change flag"
                              }, [
                                ($setup.isEyewireFlag($setup.profileFlag))
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      src: $setup.pyrIcon,
                                      class: "nge-flag-img nge-pyr-icon"
                                    }, null, 8 /* PROPS */, _hoisted_9))
                                  : ($setup.flagImgUrl($setup.profileFlag))
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 1,
                                        src: $setup.flagImgUrl($setup.profileFlag),
                                        class: "nge-flag-img"
                                      }, null, 8 /* PROPS */, _hoisted_10))
                                    : (_openBlock(), _createElementBlock("img", {
                                        key: 2,
                                        src: $setup.pyrIcon,
                                        class: "nge-flag-img nge-pyr-icon"
                                      }, null, 8 /* PROPS */, _hoisted_11))
                              ], 2 /* CLASS */),
                              _createVNode(_Transition, { name: "nge-flag-picker" }, {
                                default: _withCtx(() => [
                                  ($setup.showFlagPicker)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.ALL_FLAGS, (f) => {
                                          return _createElementVNode("button", {
                                            key: f,
                                            class: _normalizeClass(["nge-profile-flag-opt", { 'nge-profile-flag-opt--active': $setup.prefs.flag === f }]),
                                            onClick: $event => ($setup.setFlag(f))
                                          }, [
                                            _createElementVNode("img", {
                                              src: $setup.flagImgUrl(f),
                                              class: "nge-flag-img nge-flag-img--picker"
                                            }, null, 8 /* PROPS */, _hoisted_14)
                                          ], 10 /* CLASS, PROPS */, _hoisted_13)
                                        }), 64 /* STABLE_FRAGMENT */))
                                      ]))
                                    : _createCommentVNode("v-if", true)
                                ]),
                                _: 1 /* STABLE */
                              })
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                              ($setup.isEyewireFlag($setup.profileFlag))
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: $setup.pyrIcon,
                                    class: "nge-flag-img nge-pyr-icon",
                                    style: {"width":"24px","height":"24px"}
                                  }, null, 8 /* PROPS */, _hoisted_16))
                                : ($setup.flagImgUrl($setup.profileFlag))
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 1,
                                      src: $setup.flagImgUrl($setup.profileFlag),
                                      class: "nge-flag-img",
                                      style: {"width":"28px","height":"20px"}
                                    }, null, 8 /* PROPS */, _hoisted_17))
                                  : _createCommentVNode("v-if", true)
                            ])),
                        _createElementVNode("div", _hoisted_18, _toDisplayString($setup.profileName), 1 /* TEXT */),
                        (!$setup.viewingOtherUser)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 2,
                              class: "nge-profile-edit-btn",
                              onClick: _cache[8] || (_cache[8] = $event => ($setup.activeTab = 'settings')),
                              title: "Edit Profile — set bio, flag, and more"
                            }, "⚙"))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _createCommentVNode(" The handle people actually use to tag you in chat, so it\n                 belongs on the profile next to the name. "),
                      ($setup.profileUsername)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, "@" + _toDisplayString($setup.profileUsername), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                      _createCommentVNode(" Email is deliberately NOT shown. It was rendered for whoever's\n                 profile was open, which exposed other users' addresses to\n                 anyone who clicked their name in chat. The username is the\n                 public identifier; the address stays private. "),
                      (!$setup.viewingOtherUser)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            ($setup.prefs.bio)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString($setup.prefs.bio), 1 /* TEXT */))
                              : (_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  class: "nge-profile-bio-add",
                                  onClick: _cache[9] || (_cache[9] = $event => ($setup.activeTab = 'settings'))
                                }, " + Add a bio "))
                          ], 64 /* STABLE_FRAGMENT */))
                        : _createCommentVNode("v-if", true)
                    ]))
                  : _createCommentVNode("v-if", true),
                _createCommentVNode(" Edits stats "),
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _createElementVNode("div", _hoisted_23, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([
                {label:'Today',    val:$setup.profileStats.editsToday,    merges:$setup.profileStats.mergesToday,    splits:$setup.profileStats.splitsToday},
                {label:'Past 7d',  val:$setup.profileStats.editsThisWeek, merges:$setup.profileStats.mergesThisWeek, splits:$setup.profileStats.splitsThisWeek},
                {label:'All Time', val:$setup.profileStats.editsAllTime,  merges:$setup.profileStats.mergesAllTime,  splits:$setup.profileStats.splitsAllTime},
              ], (col, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "nge-profile-stat-col",
                        key: i
                      }, [
                        _createElementVNode("div", _hoisted_24, _toDisplayString(col.label), 1 /* TEXT */),
                        _createElementVNode("div", _hoisted_25, [
                          _createVNode($setup["RollUp"], {
                            value: col.val
                          }, null, 8 /* PROPS */, ["value"])
                        ]),
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("span", _hoisted_27, [
                            _hoisted_28,
                            _createTextVNode(" " + _toDisplayString(col.merges), 1 /* TEXT */)
                          ]),
                          _createElementVNode("span", _hoisted_29, [
                            _hoisted_30,
                            _createTextVNode(" " + _toDisplayString(col.splits), 1 /* TEXT */)
                          ])
                        ])
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ]),
                _createCommentVNode(" Cells stats "),
                (!$setup.viewingOtherUser)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                      _hoisted_32,
                      _createCommentVNode(" Sub-label row removed (Amy): tooltips carry the definitions,\n                 and each stat sits in its own highlighted tile. "),
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, [
                          _hoisted_35,
                          _createElementVNode("div", _hoisted_36, [
                            _createVNode($setup["RollUp"], {
                              value: $setup.completedCells.length
                            }, null, 8 /* PROPS */, ["value"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_37, [
                          _hoisted_38,
                          _createElementVNode("div", _hoisted_39, [
                            _createVNode($setup["RollUp"], {
                              value: $setup.identifiedCells.length
                            }, null, 8 /* PROPS */, ["value"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_40, [
                          _hoisted_41,
                          _createElementVNode("div", _hoisted_42, [
                            _createVNode($setup["RollUp"], {
                              value: $setup.filteredCellHistory.length
                            }, null, 8 /* PROPS */, ["value"])
                          ])
                        ]),
                        ($setup.playerAssists > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                              _hoisted_44,
                              _createElementVNode("div", _hoisted_45, _toDisplayString($setup.playerAssists), 1 /* TEXT */)
                            ]))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _createCommentVNode(" Scout Report: tags placed and fixed "),
                      _hoisted_46,
                      _createElementVNode("div", _hoisted_47, [
                        _createElementVNode("div", _hoisted_48, [
                          _hoisted_49,
                          _createElementVNode("div", _hoisted_50, [
                            _createVNode($setup["RollUp"], {
                              value: $setup.myTagsPlaced.length
                            }, null, 8 /* PROPS */, ["value"])
                          ]),
                          _hoisted_51
                        ]),
                        _createElementVNode("div", _hoisted_52, [
                          _hoisted_53,
                          _createElementVNode("div", _hoisted_54, [
                            _createVNode($setup["RollUp"], {
                              value: $setup.myTagsFixed.length
                            }, null, 8 /* PROPS */, ["value"])
                          ]),
                          _hoisted_55
                        ]),
                        _createElementVNode("div", _hoisted_56, [
                          _hoisted_57,
                          _createElementVNode("div", _hoisted_58, [
                            _createVNode($setup["RollUp"], {
                              value: $setup.tagsIFixed.length
                            }, null, 8 /* PROPS */, ["value"])
                          ]),
                          _hoisted_59
                        ])
                      ]),
                      _createCommentVNode(" Cell history list "),
                      ($setup.filteredCellHistory.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                            _createElementVNode("div", _hoisted_61, [
                              _hoisted_62,
                              ($setup.currentDataset)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: "nge-cell-list-dataset",
                                    title: 'Filtered to ' + $setup.currentDataset
                                  }, _toDisplayString($setup.currentDataset), 9 /* TEXT, PROPS */, _hoisted_63))
                                : _createCommentVNode("v-if", true)
                            ]),
                            _hoisted_64,
                            _createElementVNode("div", _hoisted_65, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredCellHistory.slice(0, 50), (cell) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: cell.segId,
                                  class: "nge-cell-row",
                                  title: cell.nickname ? `${cell.nickname} (${cell.segId})` : `Jump to ${cell.segId}`
                                }, [
                                  _createElementVNode("button", {
                                    class: _normalizeClass(["nge-cell-fav", { 'nge-cell-fav--active': cell.isFavorite }]),
                                    onClick: _withModifiers($event => ($setup.historyStore.toggleFavorite(cell.segId)), ["stop"]),
                                    title: "Toggle favorite"
                                  }, _toDisplayString(cell.isFavorite ? '★' : '☆'), 11 /* TEXT, CLASS, PROPS */, _hoisted_67),
                                  _createElementVNode("span", {
                                    class: _normalizeClass(["nge-cell-pip", $setup.cellStatusClass(cell)])
                                  }, _toDisplayString($setup.cellStatusIcon(cell)), 3 /* TEXT, CLASS */),
                                  _createElementVNode("span", {
                                    class: "nge-cell-id",
                                    onClick: $event => ($setup.handleJumpToCell(cell.segId))
                                  }, _toDisplayString(cell.nickname || $setup.truncateId(cell.segId)), 9 /* TEXT, PROPS */, _hoisted_68),
                                  (cell.cellType)
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 0,
                                        class: "nge-cell-type",
                                        onClick: $event => ($setup.handleJumpToCell(cell.segId))
                                      }, _toDisplayString(cell.cellType), 9 /* TEXT, PROPS */, _hoisted_69))
                                    : _createCommentVNode("v-if", true),
                                  _createElementVNode("span", {
                                    class: "nge-cell-time",
                                    onClick: $event => ($setup.handleJumpToCell(cell.segId))
                                  }, _toDisplayString($setup.relativeTime(cell.updatedAt)), 9 /* TEXT, PROPS */, _hoisted_70),
                                  _createElementVNode("button", {
                                    class: "nge-cell-rename",
                                    onClick: _withModifiers($event => ($setup.promptNickname(cell.segId)), ["stop"]),
                                    title: "Rename this cell"
                                  }, "✎", 8 /* PROPS */, _hoisted_71)
                                ], 8 /* PROPS */, _hoisted_66))
                              }), 128 /* KEYED_FRAGMENT */))
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_72, " Select segments and mark complete or set cell type to build your history. "))
                    ]))
                  : _createCommentVNode("v-if", true)
              ]),
              _createCommentVNode(" end left column "),
              _createCommentVNode(" CENTER: countdown + badges + streak "),
              _createElementVNode("div", _hoisted_73, [
                _createCommentVNode(" Proofreading Achievements (building track) "),
                _createElementVNode("div", _hoisted_74, [
                  _hoisted_75,
                  ($setup.nextBuildingAchievement)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                        _createElementVNode("div", _hoisted_77, [
                          _createElementVNode("div", _hoisted_78, _toDisplayString($setup.nextBuildingAchievement.remaining.toLocaleString()) + " edits to go", 1 /* TEXT */)
                        ]),
                        _createElementVNode("div", _hoisted_79, [
                          _createElementVNode("div", {
                            class: "nge-profile-countdown-fill nge-profile-countdown-fill--building",
                            style: _normalizeStyle({ width: $setup.nextBuildingAchievement.pct + '%' })
                          }, null, 4 /* STYLE */)
                        ])
                      ]))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("div", _hoisted_80, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.displayedBuildingBadges, (badge) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: badge.id,
                        class: _normalizeClass(["nge-profile-badge nge-profile-badge--building", {
                  'nge-profile-badge--selected': $setup.selectedBadge?.id === badge.id,
                  'nge-profile-badge--latest': $setup.latestEarnedBadge?.id === badge.id,
                }]),
                        title: $setup.badgeTooltip(badge),
                        onClick: $event => ($setup.onBadgeClick(badge))
                      }, [
                        _createElementVNode("div", _hoisted_82, [
                          _createElementVNode("img", {
                            src: $setup.getBadgeUrl(badge.imageKey),
                            alt: badge.name,
                            class: _normalizeClass(["nge-profile-badge-icon", `nge-badge--${badge.slug}`])
                          }, null, 10 /* CLASS, PROPS */, _hoisted_83)
                        ]),
                        _createElementVNode("div", _hoisted_84, _toDisplayString(badge.name), 1 /* TEXT */)
                      ], 10 /* CLASS, PROPS */, _hoisted_81))
                    }), 128 /* KEYED_FRAGMENT */)),
                    _createCommentVNode(" Next locked badge teaser "),
                    ($setup.earnedBuildingBadges.next && !$setup.showBuildingViewAll)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_85, _hoisted_87))
                      : _createCommentVNode("v-if", true),
                    _createCommentVNode(" \"View All\" tile at end of row 2 "),
                    ($setup.showBuildingViewAll && !$setup.showAllBuilding)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: "nge-profile-badge nge-profile-badge--viewall",
                          title: "View all badges in Trophy Case",
                          onClick: _cache[10] || (_cache[10] = $event => ($setup.activeTab = 'trophyCase'))
                        }, _hoisted_90))
                      : _createCommentVNode("v-if", true)
                  ]),
                  ($setup.earnedBuildingBadges.earned.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_91, " Make your first edit to earn a badge! "))
                    : _createCommentVNode("v-if", true)
                ]),
                _createCommentVNode(" Divider between achievement tracks "),
                _hoisted_92,
                _createCommentVNode(" Cell Achievements (exploration track) "),
                _createElementVNode("div", _hoisted_93, [
                  _hoisted_94,
                  ($setup.nextExplorationAchievement)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                        _createElementVNode("div", _hoisted_96, [
                          _createElementVNode("div", _hoisted_97, _toDisplayString($setup.nextExplorationAchievement.remaining.toLocaleString()) + " cells to go", 1 /* TEXT */)
                        ]),
                        _createElementVNode("div", _hoisted_98, [
                          _createElementVNode("div", {
                            class: "nge-profile-countdown-fill nge-profile-countdown-fill--exploration",
                            style: _normalizeStyle({ width: $setup.nextExplorationAchievement.pct + '%' })
                          }, null, 4 /* STYLE */)
                        ])
                      ]))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("div", _hoisted_99, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.displayedExplorationBadges, (badge) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: badge.id,
                        class: _normalizeClass(["nge-profile-badge nge-profile-badge--exploration", {
                  'nge-profile-badge--selected': $setup.selectedBadge?.id === badge.id,
                  'nge-profile-badge--latest': $setup.latestEarnedBadge?.id === badge.id,
                }]),
                        title: $setup.badgeTooltip(badge),
                        onClick: $event => ($setup.onBadgeClick(badge))
                      }, [
                        _createElementVNode("div", _hoisted_101, [
                          _createElementVNode("img", {
                            src: $setup.getBadgeUrl(badge.imageKey),
                            alt: badge.name,
                            class: _normalizeClass(["nge-profile-badge-icon", `nge-badge--${badge.slug}`])
                          }, null, 10 /* CLASS, PROPS */, _hoisted_102)
                        ]),
                        _createElementVNode("div", _hoisted_103, _toDisplayString(badge.name), 1 /* TEXT */)
                      ], 10 /* CLASS, PROPS */, _hoisted_100))
                    }), 128 /* KEYED_FRAGMENT */)),
                    _createCommentVNode(" Next locked badge teaser "),
                    ($setup.earnedExplorationBadges.next && !$setup.showExplorationViewAll)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_104, _hoisted_106))
                      : _createCommentVNode("v-if", true),
                    _createCommentVNode(" \"View All\" tile at end of row 2 "),
                    ($setup.showExplorationViewAll && !$setup.showAllExploration)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: "nge-profile-badge nge-profile-badge--viewall",
                          title: "View all badges in Trophy Case",
                          onClick: _cache[11] || (_cache[11] = $event => ($setup.activeTab = 'trophyCase'))
                        }, _hoisted_109))
                      : _createCommentVNode("v-if", true)
                  ]),
                  ($setup.earnedExplorationBadges.earned.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_110, " Complete your first cell to earn a badge! "))
                    : _createCommentVNode("v-if", true)
                ]),
                _createCommentVNode(" Special Awards (admin-awarded badges) "),
                ($setup.profileSpecialBadges.length > 0)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _hoisted_111,
                      _createElementVNode("div", _hoisted_112, [
                        _hoisted_113,
                        _createElementVNode("div", _hoisted_114, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.displayedSpecialBadges, (award) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: award.id,
                              class: _normalizeClass(["nge-profile-badge", { 'nge-profile-badge--selected': $setup.selectedSpecialBadge?.id === award.id }]),
                              title: $setup.specialBadgeTooltip(award),
                              onClick: $event => ($setup.onSpecialBadgeClick(award))
                            }, [
                              _createElementVNode("div", _hoisted_116, [
                                _createElementVNode("img", {
                                  src: award.badge?.thumbnail_url || award.badge?.image_url,
                                  alt: award.badge?.name,
                                  class: "nge-profile-badge-icon"
                                }, null, 8 /* PROPS */, _hoisted_117)
                              ]),
                              _createElementVNode("div", _hoisted_118, _toDisplayString(award.badge?.name || 'Award'), 1 /* TEXT */)
                            ], 10 /* CLASS, PROPS */, _hoisted_115))
                          }), 128 /* KEYED_FRAGMENT */)),
                          _createCommentVNode(" View All tile when overflow "),
                          ($setup.showSpecialViewAll)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "nge-profile-badge nge-profile-badge--viewall",
                                title: "View all special awards",
                                onClick: _cache[12] || (_cache[12] = $event => ($setup.showAllSpecialModal = true))
                              }, _hoisted_121))
                            : _createCommentVNode("v-if", true)
                        ])
                      ])
                    ], 64 /* STABLE_FRAGMENT */))
                  : _createCommentVNode("v-if", true)
              ]),
              _createCommentVNode(" end center column "),
              _createCommentVNode(" RIGHT: latest badge highlight  <->  badge detail "),
              _createElementVNode("div", _hoisted_122, [
                _createVNode(_Transition, {
                  name: "nge-viz-swap",
                  mode: "out-in"
                }, {
                  default: _withCtx(() => [
                    ($setup.selectedSpecialBadge)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_123, [
                          _createElementVNode("img", {
                            src: $setup.selectedSpecialBadge.badge?.image_url || $setup.selectedSpecialBadge.badge?.thumbnail_url,
                            alt: $setup.selectedSpecialBadge.badge?.name,
                            class: "nge-profile-viz-badge-icon nge-profile-viz-badge-icon--large"
                          }, null, 8 /* PROPS */, _hoisted_124),
                          _createElementVNode("div", _hoisted_125, _toDisplayString($setup.selectedSpecialBadge.badge?.name || 'Award'), 1 /* TEXT */),
                          ($setup.selectedSpecialBadge.badge?.description)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_126, _toDisplayString($setup.selectedSpecialBadge.badge.description), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true),
                          _createElementVNode("div", _hoisted_127, " Awarded " + _toDisplayString($setup.relativeTime($setup.selectedSpecialBadge.awarded_at)), 1 /* TEXT */),
                          _createElementVNode("button", {
                            class: "nge-profile-viz-badge-back",
                            onClick: _cache[13] || (_cache[13] = $event => ($setup.selectedSpecialBadge = null))
                          }, " ← Back ")
                        ]))
                      : (!$setup.selectedBadge)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createCommentVNode(" Default view: favorite badge → favorite special badge → latest earned "),
                            _createElementVNode("div", _hoisted_128, [
                              ($setup.favoriteBadge)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _hoisted_129,
                                    _createElementVNode("img", {
                                      src: $setup.getBadgeUrl($setup.favoriteBadge.imageKey),
                                      alt: $setup.favoriteBadge.name,
                                      class: _normalizeClass(["nge-profile-viz-badge-icon", `nge-badge--${$setup.favoriteBadge.slug}`])
                                    }, null, 10 /* CLASS, PROPS */, _hoisted_130),
                                    _createElementVNode("div", _hoisted_131, _toDisplayString($setup.favoriteBadge.name), 1 /* TEXT */),
                                    _createElementVNode("div", _hoisted_132, _toDisplayString($setup.favoriteBadge.description), 1 /* TEXT */),
                                    _createElementVNode("div", _hoisted_133, [
                                      _createTextVNode(" Unlocked at "),
                                      _createElementVNode("strong", null, _toDisplayString($setup.favoriteBadge.threshold.toLocaleString()), 1 /* TEXT */),
                                      _createTextVNode(" " + _toDisplayString($setup.thresholdLabel($setup.favoriteBadge)), 1 /* TEXT */)
                                    ])
                                  ], 64 /* STABLE_FRAGMENT */))
                                : ($setup.favoriteSpecialBadge)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _hoisted_134,
                                      _createElementVNode("img", {
                                        src: $setup.favoriteSpecialBadge.badge?.image_url || $setup.favoriteSpecialBadge.badge?.thumbnail_url,
                                        alt: $setup.favoriteSpecialBadge.badge?.name,
                                        class: "nge-profile-viz-badge-icon nge-profile-viz-badge-icon--large"
                                      }, null, 8 /* PROPS */, _hoisted_135),
                                      _createElementVNode("div", _hoisted_136, _toDisplayString($setup.favoriteSpecialBadge.badge?.name || 'Award'), 1 /* TEXT */),
                                      ($setup.favoriteSpecialBadge.badge?.description)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_137, _toDisplayString($setup.favoriteSpecialBadge.badge.description), 1 /* TEXT */))
                                        : _createCommentVNode("v-if", true),
                                      _createElementVNode("div", _hoisted_138, [
                                        _createTextVNode(" Won on "),
                                        _createElementVNode("strong", null, _toDisplayString($setup.formatDate($setup.favoriteSpecialBadge.awarded_at)), 1 /* TEXT */)
                                      ])
                                    ], 64 /* STABLE_FRAGMENT */))
                                  : ($setup.latestEarnedBadge)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                        _hoisted_139,
                                        _createElementVNode("img", {
                                          src: $setup.getBadgeUrl($setup.latestEarnedBadge.imageKey),
                                          alt: $setup.latestEarnedBadge.name,
                                          class: _normalizeClass(["nge-profile-viz-badge-icon", `nge-badge--${$setup.latestEarnedBadge.slug}`])
                                        }, null, 10 /* CLASS, PROPS */, _hoisted_140),
                                        _createElementVNode("div", _hoisted_141, _toDisplayString($setup.latestEarnedBadge.name), 1 /* TEXT */),
                                        _createElementVNode("div", _hoisted_142, _toDisplayString($setup.latestEarnedBadge.description), 1 /* TEXT */),
                                        _createElementVNode("div", _hoisted_143, [
                                          _createTextVNode(" Earned at "),
                                          _createElementVNode("strong", null, _toDisplayString($setup.latestEarnedBadge.threshold.toLocaleString()), 1 /* TEXT */),
                                          _createTextVNode(" " + _toDisplayString($setup.thresholdLabel($setup.latestEarnedBadge)), 1 /* TEXT */)
                                        ])
                                      ], 64 /* STABLE_FRAGMENT */))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                        _hoisted_144,
                                        _hoisted_145
                                      ], 64 /* STABLE_FRAGMENT */))
                            ])
                          ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createCommentVNode(" Badge detail view (when a badge is clicked) "),
                            _createElementVNode("div", _hoisted_146, [
                              _createElementVNode("img", {
                                src: $setup.getBadgeUrl($setup.selectedBadge.imageKey),
                                alt: $setup.selectedBadge.name,
                                class: _normalizeClass(["nge-profile-viz-badge-icon nge-profile-viz-badge-icon--large", `nge-badge--${$setup.selectedBadge.slug}`])
                              }, null, 10 /* CLASS, PROPS */, _hoisted_147),
                              _createElementVNode("div", _hoisted_148, _toDisplayString($setup.selectedBadge.name), 1 /* TEXT */),
                              _createElementVNode("div", _hoisted_149, _toDisplayString($setup.selectedBadge.description), 1 /* TEXT */),
                              _createElementVNode("div", _hoisted_150, [
                                _createTextVNode(" Unlocked at "),
                                _createElementVNode("strong", null, _toDisplayString($setup.selectedBadge.threshold.toLocaleString()), 1 /* TEXT */),
                                _createTextVNode(" " + _toDisplayString($setup.thresholdLabel($setup.selectedBadge)), 1 /* TEXT */)
                              ]),
                              _createElementVNode("button", {
                                class: "nge-profile-viz-badge-back",
                                onClick: _cache[14] || (_cache[14] = $event => ($setup.selectedBadge = null))
                              }, " ← " + _toDisplayString($setup.favoriteBadge || $setup.favoriteSpecialBadge ? 'Back to favorite' : 'Back'), 1 /* TEXT */)
                            ])
                          ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                  ]),
                  _: 1 /* STABLE */
                }),
                _createCommentVNode(" Divider between badge and streak "),
                _hoisted_151,
                _createCommentVNode(" Weekly podium counts (🥇 × N etc.) — one row per metric "),
                ($setup.anyPodium)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_152, [
                      _hoisted_153,
                      _createCommentVNode(" Edits podium "),
                      ($setup.podiumTotal > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_154, [
                            _hoisted_155,
                            _createElementVNode("div", _hoisted_156, [
                              ($setup.podium.gold > 0)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "nge-profile-podium-tile nge-profile-podium-tile--gold",
                                    title: `Finished 1st place in edits ${$setup.podium.gold} week${$setup.podium.gold === 1 ? '' : 's'}`
                                  }, [
                                    _hoisted_158,
                                    _createElementVNode("span", _hoisted_159, "× " + _toDisplayString($setup.podium.gold), 1 /* TEXT */)
                                  ], 8 /* PROPS */, _hoisted_157))
                                : _createCommentVNode("v-if", true),
                              ($setup.podium.silver > 0)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    class: "nge-profile-podium-tile nge-profile-podium-tile--silver",
                                    title: `Finished 2nd place in edits ${$setup.podium.silver} week${$setup.podium.silver === 1 ? '' : 's'}`
                                  }, [
                                    _hoisted_161,
                                    _createElementVNode("span", _hoisted_162, "× " + _toDisplayString($setup.podium.silver), 1 /* TEXT */)
                                  ], 8 /* PROPS */, _hoisted_160))
                                : _createCommentVNode("v-if", true),
                              ($setup.podium.bronze > 0)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 2,
                                    class: "nge-profile-podium-tile nge-profile-podium-tile--bronze",
                                    title: `Finished 3rd place in edits ${$setup.podium.bronze} week${$setup.podium.bronze === 1 ? '' : 's'}`
                                  }, [
                                    _hoisted_164,
                                    _createElementVNode("span", _hoisted_165, "× " + _toDisplayString($setup.podium.bronze), 1 /* TEXT */)
                                  ], 8 /* PROPS */, _hoisted_163))
                                : _createCommentVNode("v-if", true)
                            ])
                          ]))
                        : _createCommentVNode("v-if", true),
                      _createCommentVNode(" Completions podium "),
                      ($setup.podiumCompletionsTotal > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_166, [
                            _hoisted_167,
                            _createElementVNode("div", _hoisted_168, [
                              ($setup.podiumCompletions.gold > 0)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "nge-profile-podium-tile nge-profile-podium-tile--gold",
                                    title: `Finished 1st place in cells ${$setup.podiumCompletions.gold} week${$setup.podiumCompletions.gold === 1 ? '' : 's'}`
                                  }, [
                                    _hoisted_170,
                                    _createElementVNode("span", _hoisted_171, "× " + _toDisplayString($setup.podiumCompletions.gold), 1 /* TEXT */)
                                  ], 8 /* PROPS */, _hoisted_169))
                                : _createCommentVNode("v-if", true),
                              ($setup.podiumCompletions.silver > 0)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    class: "nge-profile-podium-tile nge-profile-podium-tile--silver",
                                    title: `Finished 2nd place in cells ${$setup.podiumCompletions.silver} week${$setup.podiumCompletions.silver === 1 ? '' : 's'}`
                                  }, [
                                    _hoisted_173,
                                    _createElementVNode("span", _hoisted_174, "× " + _toDisplayString($setup.podiumCompletions.silver), 1 /* TEXT */)
                                  ], 8 /* PROPS */, _hoisted_172))
                                : _createCommentVNode("v-if", true),
                              ($setup.podiumCompletions.bronze > 0)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 2,
                                    class: "nge-profile-podium-tile nge-profile-podium-tile--bronze",
                                    title: `Finished 3rd place in cells ${$setup.podiumCompletions.bronze} week${$setup.podiumCompletions.bronze === 1 ? '' : 's'}`
                                  }, [
                                    _hoisted_176,
                                    _createElementVNode("span", _hoisted_177, "× " + _toDisplayString($setup.podiumCompletions.bronze), 1 /* TEXT */)
                                  ], 8 /* PROPS */, _hoisted_175))
                                : _createCommentVNode("v-if", true)
                            ])
                          ]))
                        : _createCommentVNode("v-if", true)
                    ]))
                  : _createCommentVNode("v-if", true),
                _createCommentVNode(" Streak + Activity Chart "),
                _createElementVNode("div", _hoisted_178, [
                  _hoisted_179,
                  ($setup.profileStats.currentStreak > 0 || $setup.profileStats.longestStreak > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_180, [
                        _createElementVNode("div", _hoisted_181, [
                          _hoisted_182,
                          _createElementVNode("span", _hoisted_183, _toDisplayString($setup.profileStats.currentStreak), 1 /* TEXT */),
                          _createElementVNode("span", _hoisted_184, "day" + _toDisplayString($setup.profileStats.currentStreak === 1 ? '' : 's') + " current", 1 /* TEXT */)
                        ]),
                        ($setup.profileStats.longestStreak > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_185, [
                              _hoisted_186,
                              _createElementVNode("span", _hoisted_187, _toDisplayString($setup.profileStats.longestStreak) + "d", 1 /* TEXT */)
                            ]))
                          : _createCommentVNode("v-if", true)
                      ]))
                    : _createCommentVNode("v-if", true),
                  _createCommentVNode(" 14-day activity chart "),
                  _createElementVNode("div", _hoisted_188, [
                    _hoisted_189,
                    _createElementVNode("div", _hoisted_190, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.last14Days, (day) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: day.date,
                          class: "nge-profile-chart-col",
                          title: `${day.date}: ${day.edits} edits, ${day.completions} completions`
                        }, [
                          _createElementVNode("div", _hoisted_192, [
                            (day.completions > 0)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: "nge-profile-chart-bar nge-profile-chart-bar--completion",
                                  style: _normalizeStyle({ height: Math.max(2, (day.completions / $setup.chartMax) * 48) + 'px' })
                                }, null, 4 /* STYLE */))
                              : _createCommentVNode("v-if", true),
                            (day.edits > 0)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 1,
                                  class: "nge-profile-chart-bar nge-profile-chart-bar--edit",
                                  style: _normalizeStyle({ height: Math.max(2, (day.edits / $setup.chartMax) * 48) + 'px' })
                                }, null, 4 /* STYLE */))
                              : _createCommentVNode("v-if", true)
                          ]),
                          _createElementVNode("div", _hoisted_193, _toDisplayString(day.label), 1 /* TEXT */)
                        ], 8 /* PROPS */, _hoisted_191))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _hoisted_194
                  ])
                ])
              ]),
              _createCommentVNode(" end right column ")
            ]))
          : ($setup.activeTab === 'trophyCase')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createCommentVNode(" end .nge-profile-body (Overview) "),
                _createCommentVNode(" ── Trophy Case tab ─────────────────────────────────── "),
                _createElementVNode("div", _hoisted_195, [
                  _createElementVNode("div", _hoisted_196, [
                    _createCommentVNode(" ── Featured badge banner ── "),
                    ($setup.selectedSpecialBadge)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_197, [
                          _createElementVNode("div", _hoisted_198, [
                            _hoisted_199,
                            _hoisted_200,
                            _hoisted_201,
                            _hoisted_202,
                            _hoisted_203,
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (i) => {
                              return _createElementVNode("span", {
                                key: i,
                                class: "nge-trophy-orbit-dot",
                                style: _normalizeStyle({ '--j': i })
                              }, null, 4 /* STYLE */)
                            }), 64 /* STABLE_FRAGMENT */)),
                            _hoisted_204
                          ]),
                          _createElementVNode("img", {
                            src: $setup.selectedSpecialBadge.badge?.image_url || $setup.selectedSpecialBadge.badge?.thumbnail_url,
                            alt: $setup.selectedSpecialBadge.badge?.name,
                            class: "nge-trophy-featured-icon nge-trophy-featured-icon--animated",
                            onClick: _cache[15] || (_cache[15] = $event => ($setup.zoomBadge($setup.selectedSpecialBadge.badge?.image_url || $setup.selectedSpecialBadge.badge?.thumbnail_url, $setup.selectedSpecialBadge.badge?.name, $setup.selectedSpecialBadge.badge?.description, 'Won on ' + $setup.formatDate($setup.selectedSpecialBadge.awarded_at))))
                          }, null, 8 /* PROPS */, _hoisted_205),
                          _createElementVNode("div", _hoisted_206, [
                            _createElementVNode("div", _hoisted_207, _toDisplayString($setup.selectedSpecialBadge.badge?.name || 'Award'), 1 /* TEXT */),
                            ($setup.selectedSpecialBadge.badge?.description)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_208, _toDisplayString($setup.selectedSpecialBadge.badge.description), 1 /* TEXT */))
                              : _createCommentVNode("v-if", true),
                            _hoisted_209,
                            _createElementVNode("div", _hoisted_210, [
                              _createTextVNode(" Won on "),
                              _createElementVNode("strong", null, _toDisplayString($setup.formatDate($setup.selectedSpecialBadge.awarded_at)), 1 /* TEXT */)
                            ]),
                            ($setup.favoriteBadgeSlug === ($setup.selectedSpecialBadge.badge?.slug || `special-${$setup.selectedSpecialBadge.id}`))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_211, "★ Your favorite badge"))
                              : _createCommentVNode("v-if", true)
                          ]),
                          _createElementVNode("button", {
                            class: _normalizeClass(["nge-trophy-featured-star", { 'nge-trophy-featured-star--active': $setup.favoriteBadgeSlug === ($setup.selectedSpecialBadge.badge?.slug || `special-${$setup.selectedSpecialBadge.id}`) }]),
                            title: $setup.favoriteBadgeSlug === ($setup.selectedSpecialBadge.badge?.slug || `special-${$setup.selectedSpecialBadge.id}`) ? 'Remove from favorites' : 'Set as favorite badge',
                            onClick: _cache[16] || (_cache[16] = $event => ($setup.toggleFavoriteSpecialBadge($setup.selectedSpecialBadge)))
                          }, _toDisplayString($setup.favoriteBadgeSlug === ($setup.selectedSpecialBadge.badge?.slug || `special-${$setup.selectedSpecialBadge.id}`) ? '★' : '☆'), 11 /* TEXT, CLASS, PROPS */, _hoisted_212)
                        ]))
                      : ($setup.favoriteSpecialBadge && !$setup.selectedBadge)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_213, [
                            _createElementVNode("div", _hoisted_214, [
                              _hoisted_215,
                              _hoisted_216,
                              _hoisted_217,
                              _hoisted_218,
                              _hoisted_219,
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (i) => {
                                return _createElementVNode("span", {
                                  key: i,
                                  class: "nge-trophy-orbit-dot",
                                  style: _normalizeStyle({ '--j': i })
                                }, null, 4 /* STYLE */)
                              }), 64 /* STABLE_FRAGMENT */)),
                              _hoisted_220
                            ]),
                            _createElementVNode("img", {
                              src: $setup.favoriteSpecialBadge.badge?.image_url || $setup.favoriteSpecialBadge.badge?.thumbnail_url,
                              alt: $setup.favoriteSpecialBadge.badge?.name,
                              class: "nge-trophy-featured-icon nge-trophy-featured-icon--animated",
                              onClick: _cache[17] || (_cache[17] = $event => ($setup.zoomBadge($setup.favoriteSpecialBadge.badge?.image_url || $setup.favoriteSpecialBadge.badge?.thumbnail_url, $setup.favoriteSpecialBadge.badge?.name, $setup.favoriteSpecialBadge.badge?.description, 'Won on ' + $setup.formatDate($setup.favoriteSpecialBadge.awarded_at))))
                            }, null, 8 /* PROPS */, _hoisted_221),
                            _createElementVNode("div", _hoisted_222, [
                              _createElementVNode("div", _hoisted_223, _toDisplayString($setup.favoriteSpecialBadge.badge?.name || 'Award'), 1 /* TEXT */),
                              ($setup.favoriteSpecialBadge.badge?.description)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_224, _toDisplayString($setup.favoriteSpecialBadge.badge.description), 1 /* TEXT */))
                                : _createCommentVNode("v-if", true),
                              _hoisted_225,
                              _createElementVNode("div", _hoisted_226, [
                                _createTextVNode(" Won on "),
                                _createElementVNode("strong", null, _toDisplayString($setup.formatDate($setup.favoriteSpecialBadge.awarded_at)), 1 /* TEXT */)
                              ]),
                              _hoisted_227
                            ]),
                            _createElementVNode("button", {
                              class: "nge-trophy-featured-star nge-trophy-featured-star--active",
                              title: "Remove from favorites",
                              onClick: _cache[18] || (_cache[18] = $event => ($setup.toggleFavoriteSpecialBadge($setup.favoriteSpecialBadge)))
                            }, "★")
                          ]))
                        : ($setup.featuredBadge)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_228, [
                              _createElementVNode("div", _hoisted_229, [
                                _hoisted_230,
                                _hoisted_231,
                                _hoisted_232,
                                _hoisted_233,
                                _hoisted_234,
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (i) => {
                                  return _createElementVNode("span", {
                                    key: i,
                                    class: "nge-trophy-orbit-dot",
                                    style: _normalizeStyle({ '--j': i })
                                  }, null, 4 /* STYLE */)
                                }), 64 /* STABLE_FRAGMENT */)),
                                _hoisted_235
                              ]),
                              _createElementVNode("img", {
                                src: $setup.getBadgeUrl($setup.featuredBadge.imageKey),
                                alt: $setup.featuredBadge.name,
                                class: _normalizeClass(["nge-trophy-featured-icon nge-trophy-featured-icon--animated", `nge-badge--${$setup.featuredBadge.slug}`]),
                                onClick: _cache[19] || (_cache[19] = $event => ($setup.zoomBadge($setup.getBadgeUrl($setup.featuredBadge.imageKey), $setup.featuredBadge.name, $setup.featuredBadge.description, 'Unlocked at ' + $setup.featuredBadge.threshold.toLocaleString() + ' ' + $setup.thresholdLabel($setup.featuredBadge))))
                              }, null, 10 /* CLASS, PROPS */, _hoisted_236),
                              _createElementVNode("div", _hoisted_237, [
                                _createElementVNode("div", _hoisted_238, _toDisplayString($setup.featuredBadge.name), 1 /* TEXT */),
                                _createElementVNode("div", _hoisted_239, _toDisplayString($setup.featuredBadge.description), 1 /* TEXT */),
                                _createElementVNode("div", _hoisted_240, [
                                  _createTextVNode(" Unlocked at "),
                                  _createElementVNode("strong", null, _toDisplayString($setup.featuredBadge.threshold.toLocaleString()), 1 /* TEXT */),
                                  _createTextVNode(" " + _toDisplayString($setup.thresholdLabel($setup.featuredBadge)), 1 /* TEXT */)
                                ]),
                                ($setup.favoriteBadgeSlug === $setup.featuredBadge.slug)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_241, "★ Your favorite badge"))
                                  : _createCommentVNode("v-if", true)
                              ]),
                              _createElementVNode("button", {
                                class: _normalizeClass(["nge-trophy-featured-star", { 'nge-trophy-featured-star--active': $setup.favoriteBadgeSlug === $setup.featuredBadge.slug }]),
                                title: $setup.favoriteBadgeSlug === $setup.featuredBadge.slug ? 'Remove from favorites' : 'Set as favorite badge',
                                onClick: _cache[20] || (_cache[20] = $event => ($setup.toggleFavoriteBadge($setup.featuredBadge)))
                              }, _toDisplayString($setup.favoriteBadgeSlug === $setup.featuredBadge.slug ? '★' : '☆'), 11 /* TEXT, CLASS, PROPS */, _hoisted_242)
                            ]))
                          : _createCommentVNode("v-if", true),
                    _createCommentVNode(" Exploration track (Cell Achievements first) "),
                    _createElementVNode("div", _hoisted_243, [
                      _createElementVNode("div", _hoisted_244, [
                        _createTextVNode("Cell Achievements "),
                        _createElementVNode("span", _hoisted_245, _toDisplayString($setup.earnedExplorationBadges.earned.length) + " earned", 1 /* TEXT */)
                      ]),
                      _createElementVNode("div", _hoisted_246, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.earnedExplorationBadges.earned, (badge) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: badge.id,
                            class: _normalizeClass(["nge-trophy-badge nge-trophy-badge--exploration", {
                  'nge-trophy-badge--selected': $setup.selectedBadge?.id === badge.id,
                  'nge-trophy-badge--favorited': $setup.favoriteBadgeSlug === badge.slug,
                }]),
                            onClick: $event => ($setup.onBadgeClick(badge))
                          }, [
                            _createElementVNode("img", {
                              src: $setup.getBadgeUrl(badge.imageKey),
                              alt: badge.name,
                              class: _normalizeClass(["nge-trophy-badge-icon", `nge-badge--${badge.slug}`])
                            }, null, 10 /* CLASS, PROPS */, _hoisted_248),
                            _createElementVNode("div", _hoisted_249, _toDisplayString(badge.name), 1 /* TEXT */),
                            _createElementVNode("div", _hoisted_250, _toDisplayString(badge.description), 1 /* TEXT */),
                            _createElementVNode("div", _hoisted_251, _toDisplayString(badge.threshold.toLocaleString()) + " cells", 1 /* TEXT */)
                          ], 10 /* CLASS, PROPS */, _hoisted_247))
                        }), 128 /* KEYED_FRAGMENT */))
                      ])
                    ]),
                    _createCommentVNode(" Proofreading track "),
                    _createElementVNode("div", _hoisted_252, [
                      _createElementVNode("div", _hoisted_253, [
                        _createTextVNode("Proofreading Achievements "),
                        _createElementVNode("span", _hoisted_254, _toDisplayString($setup.earnedBuildingBadges.earned.length) + " earned", 1 /* TEXT */)
                      ]),
                      _createElementVNode("div", _hoisted_255, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.earnedBuildingBadges.earned, (badge) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: badge.id,
                            class: _normalizeClass(["nge-trophy-badge nge-trophy-badge--building", {
                  'nge-trophy-badge--selected': $setup.selectedBadge?.id === badge.id,
                  'nge-trophy-badge--favorited': $setup.favoriteBadgeSlug === badge.slug,
                }]),
                            onClick: $event => ($setup.onBadgeClick(badge))
                          }, [
                            _createElementVNode("img", {
                              src: $setup.getBadgeUrl(badge.imageKey),
                              alt: badge.name,
                              class: _normalizeClass(["nge-trophy-badge-icon", `nge-badge--${badge.slug}`])
                            }, null, 10 /* CLASS, PROPS */, _hoisted_257),
                            _createElementVNode("div", _hoisted_258, _toDisplayString(badge.name), 1 /* TEXT */),
                            _createElementVNode("div", _hoisted_259, _toDisplayString(badge.description), 1 /* TEXT */),
                            _createElementVNode("div", _hoisted_260, _toDisplayString(badge.threshold.toLocaleString()) + " edits", 1 /* TEXT */)
                          ], 10 /* CLASS, PROPS */, _hoisted_256))
                        }), 128 /* KEYED_FRAGMENT */))
                      ])
                    ]),
                    _createCommentVNode(" Special Awards "),
                    ($setup.profileSpecialBadges.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_261, [
                          _hoisted_262,
                          _createElementVNode("div", _hoisted_263, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.profileSpecialBadges, (award) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: award.id,
                                class: _normalizeClass(["nge-trophy-badge", { 'nge-trophy-badge--selected': $setup.selectedSpecialBadge?.id === award.id }]),
                                title: $setup.specialBadgeTooltip(award),
                                onClick: $event => ($setup.onSpecialBadgeClick(award))
                              }, [
                                _createElementVNode("img", {
                                  src: award.badge?.thumbnail_url || award.badge?.image_url,
                                  alt: award.badge?.name,
                                  class: "nge-trophy-badge-icon"
                                }, null, 8 /* PROPS */, _hoisted_265),
                                _createElementVNode("div", _hoisted_266, _toDisplayString(award.badge?.name || 'Award'), 1 /* TEXT */),
                                (award.badge?.description)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_267, _toDisplayString(award.badge.description), 1 /* TEXT */))
                                  : _createCommentVNode("v-if", true)
                              ], 10 /* CLASS, PROPS */, _hoisted_264))
                            }), 128 /* KEYED_FRAGMENT */))
                          ])
                        ]))
                      : _createCommentVNode("v-if", true)
                  ])
                ])
              ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
            : _createCommentVNode("v-if", true),
        _createCommentVNode(" end Trophy Case "),
        _createCommentVNode(" ── Datasets tab: contributions per dataset + switcher ── "),
        ($setup.activeTab === 'datasets')
          ? (_openBlock(), _createElementBlock("div", _hoisted_268, [
              _hoisted_269,
              ($setup.datasetStatsLoading && !Object.keys($setup.datasetStats).length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_270, " Counting your edits… "))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_271, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.DATASETS, (ds) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: ds.id,
                    class: _normalizeClass(["nge-ds-tab-card", {
              'nge-ds-tab-card--active': $setup.canonicalDataset($setup.segLayerName(ds)) === $setup.activeDatasetCanon,
              'nge-ds-tab-card--switching': $setup.switchingDatasetId === ds.id,
            }]),
                    onClick: $event => ($setup.switchProfileDataset(ds))
                  }, [
                    _createElementVNode("div", _hoisted_273, [
                      _createElementVNode("span", _hoisted_274, _toDisplayString($setup.SPECIES_ICONS[ds.species]), 1 /* TEXT */),
                      _createElementVNode("span", _hoisted_275, _toDisplayString(ds.label), 1 /* TEXT */),
                      ($setup.canonicalDataset($setup.segLayerName(ds)) === $setup.activeDatasetCanon)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_276, "Active"))
                        : (_openBlock(), _createElementBlock("span", _hoisted_277, "Switch ▸"))
                    ]),
                    _createElementVNode("div", _hoisted_278, _toDisplayString(ds.description), 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_279, [
                      ($setup.datasetContribution(ds))
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("span", _hoisted_280, [
                              _createElementVNode("b", null, _toDisplayString(($setup.datasetContribution(ds)?.edits ?? 0).toLocaleString()), 1 /* TEXT */),
                              _createTextVNode(" edits")
                            ]),
                            _createElementVNode("span", _hoisted_281, [
                              _createElementVNode("b", null, _toDisplayString(($setup.datasetContribution(ds)?.completions ?? 0).toLocaleString()), 1 /* TEXT */),
                              _createTextVNode(" cells proofread")
                            ]),
                            _createElementVNode("span", _hoisted_282, [
                              _createElementVNode("b", null, _toDisplayString(($setup.datasetContribution(ds)?.helpRequests ?? 0).toLocaleString()), 1 /* TEXT */),
                              _createTextVNode(" help requests")
                            ]),
                            (!$setup.hasContributed(ds))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_283, "no contributions yet"))
                              : _createCommentVNode("v-if", true)
                          ], 64 /* STABLE_FRAGMENT */))
                        : (_openBlock(), _createElementBlock("span", _hoisted_284, "…"))
                    ])
                  ], 10 /* CLASS, PROPS */, _hoisted_272))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ]))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" ── Week in Science tab ───────────────────────────────── "),
        ($setup.activeTab === 'weekInScience')
          ? (_openBlock(), _createElementBlock("div", _hoisted_285, [
              _createVNode($setup["WeeklyRecapPanel"], { embedded: "" })
            ]))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" ── Admin Hub tab ─────────────────────────────────────── "),
        ($setup.activeTab === 'adminHub')
          ? (_openBlock(), _createElementBlock("div", _hoisted_286, [
              _createVNode($setup["AdminHub"], { "initial-sub-tab": $setup.adminInitialSubTab }, null, 8 /* PROPS */, ["initial-sub-tab"])
            ]))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" ── Settings tab ──────────────────────────────────────── "),
        ($setup.activeTab === 'settings')
          ? (_openBlock(), _createElementBlock("div", _hoisted_287, [
              _createVNode($setup["SettingsPanel"], { embedded: "" })
            ]))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" ── All Special Awards modal ── "),
        ($setup.showAllSpecialModal)
          ? (_openBlock(), _createElementBlock("div", {
              key: 6,
              class: "nge-special-modal-backdrop",
              onClick: _cache[22] || (_cache[22] = _withModifiers($event => ($setup.showAllSpecialModal = false), ["self"]))
            }, [
              _createElementVNode("div", _hoisted_288, [
                _createElementVNode("div", _hoisted_289, [
                  _hoisted_290,
                  _createElementVNode("button", {
                    class: "nge-special-modal-close",
                    onClick: _cache[21] || (_cache[21] = $event => ($setup.showAllSpecialModal = false))
                  }, "×")
                ]),
                _createElementVNode("div", _hoisted_291, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.profileSpecialBadges, (award) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: award.id,
                      class: "nge-special-modal-tile",
                      title: $setup.specialBadgeTooltip(award),
                      onClick: $event => {$setup.onSpecialBadgeClick(award); $setup.showAllSpecialModal = false;}
                    }, [
                      _createElementVNode("img", {
                        src: award.badge?.thumbnail_url || award.badge?.image_url,
                        alt: award.badge?.name,
                        class: "nge-special-modal-icon"
                      }, null, 8 /* PROPS */, _hoisted_293),
                      _createElementVNode("div", _hoisted_294, _toDisplayString(award.badge?.name || 'Award'), 1 /* TEXT */),
                      (award.reason)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_295, _toDisplayString(award.reason), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                    ], 8 /* PROPS */, _hoisted_292))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ], 2 /* CLASS */),
      _createCommentVNode(" Mobile fullscreen badge viewer: tap the featured badge art to see\n         it big, with a simplified award moment. Tap anywhere to close. "),
      (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
        _createVNode(_Transition, { name: "nge-bz" }, {
          default: _withCtx(() => [
            ($setup.badgeZoom)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "nge-badge-zoom",
                  onClick: _cache[23] || (_cache[23] = $event => ($setup.badgeZoom = null))
                }, [
                  _hoisted_296,
                  _hoisted_297,
                  _createElementVNode("img", {
                    src: $setup.badgeZoom.img,
                    alt: $setup.badgeZoom.name,
                    class: "nge-badge-zoom-img"
                  }, null, 8 /* PROPS */, _hoisted_298),
                  _createElementVNode("div", _hoisted_299, _toDisplayString($setup.badgeZoom.name), 1 /* TEXT */),
                  ($setup.badgeZoom.desc)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_300, _toDisplayString($setup.badgeZoom.desc), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                  ($setup.badgeZoom.meta)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_301, _toDisplayString($setup.badgeZoom.meta), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                  _hoisted_302
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          _: 1 /* STABLE */
        })
      ]))
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["class"]))
}